<template>
  <span>
    <v-btn flat icon>
      <v-icon small @click="dialog = true">
        mdi-pencil
      </v-icon>
    </v-btn>

    <v-dialog v-model="dialog" width="500" v-if="typologySizeForTax !== undefined">
      <v-card>
        <v-card-title class="headline green darken-2 white--text lighten-2">
          Editar Porte
        </v-card-title>

        <v-card-text>

          <v-form v-model="valid">
            <v-text-field
              v-model="typologySizeForTax.name"
              :rules="requiredRules"
              label="Descrição"
              required></v-text-field>
              <v-checkbox
                v-model="typologySizeForTax.old"
                :checked="typologySizeForTax.old"
                label="Antigo?"
                required
              />
          </v-form>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="closeDialog()">Cancelar</v-btn>
          <v-btn color="primary" flat @click="editTypologySizeForTax">Atualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>

import TypologySizeForTaxService from '@/services/applications/configurations/TypologySizeForTaxService';
import validationRules from '@/mixins/validation-rules';

export default {
  name: 'EditTypologySizeForTax',
  components: {},
  mixins: [validationRules],
  props: ['typologyId', 'typologySizeForTax'],
  data() {
    return {
      requiredRules: [validationRules.required],
      dialog: false,
      valid: false,
    };
  },
  methods: {
    editTypologySizeForTax() {
      const vm = this;

      TypologySizeForTaxService
        .updateTypologySize(vm.typologyId, vm.typologySizeForTax)
        .then((response) => {
          vm.$swal({
            title: 'Porte atualizado com Sucesso',
            text: '',
            type: 'success',
            confirmButtonText: 'Ok',
          }).then(() => {
            vm.$emit('update', response.data);
            vm.closeDialog();
          });
        })
        .catch((error) => {
          vm.$swal({
            title: 'Erro',
            text: error.response.data.join('\n'),
            type: 'error',
            showConfirmButton: 'Ok',
          });
        });
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
